module.exports = __webpack_public_path__ + "images/oth-pricing-banner-bg.jpg";